import React, { createContext, useContext, useState } from 'react';
import { ApiResult } from '../types';

interface DesignContextType {
  inputImage: string | null;
  setInputImage: (image: string | null) => void;
  generalInstruction: string;
  setGeneralInstruction: (text: string) => void;
  redInstruction: string;
  setRedInstruction: (text: string) => void;
  greenInstruction: string;
  setGreenInstruction: (text: string) => void;
  maskData: any;
  setMaskData: (data: any) => void;
  apiResult: ApiResult | null;
  setApiResult: (result: ApiResult | null) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
}

const DesignContext = createContext<DesignContextType | undefined>(undefined);

export const DesignProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [inputImage, setInputImage] = useState<string | null>(null);
  const [generalInstruction, setGeneralInstruction] = useState('');
  const [redInstruction, setRedInstruction] = useState('');
  const [greenInstruction, setGreenInstruction] = useState('');
  const [maskData, setMaskData] = useState<any>(null);
  const [apiResult, setApiResult] = useState<ApiResult | null>(null);
  const [loading, setLoading] = useState(false);

  return (
    <DesignContext.Provider value={{
      inputImage, setInputImage,
      generalInstruction, setGeneralInstruction,
      redInstruction, setRedInstruction,
      greenInstruction, setGreenInstruction,
      maskData, setMaskData,
      apiResult, setApiResult,
      loading, setLoading
    }}>
      {children}
    </DesignContext.Provider>
  );
};

export const useDesign = () => {
  const context = useContext(DesignContext);
  if (context === undefined) {
    throw new Error('useDesign must be used within a DesignProvider');
  }
  return context;
};
